import { useEffect } from 'react';
import { config } from '../config/config';

/**
 * Hook that initializes Google Analytics if a measurement ID is configured.
 * Also tracks page views on route changes.
 */
export function useAnalytics() {
  useEffect(() => {
    const gaId = config.analytics.gaMeasurementId;
    if (!gaId) return;

    // Load GA script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId);

    // Track page views on hash changes
    const handleHashChange = () => {
      const hash = window.location.hash || '#hero';
      gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: hash,
      });
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      document.head.removeChild(script);
    };
  }, []);
}

// Extend Window interface for gtag
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}